import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CalendarEvents } from '../models/calendarEvents';
import { Event } from '../models/event';
import { ApiService } from './api.service';
import { CognitoUtil } from './cognito.service';

@Injectable()
export class CalendarEventsService {

  calendarEventsLink = environment.calendarEventsLink;

  apiService: ApiService = new ApiService(this.http, this.cognito);

  constructor(
    private http: Http, private cognito: CognitoUtil
  ) { }

  getEventsByUser(userId: string, year: string, month: string) {
    return this.apiService.getCall('calendarEventsLink', `users/${userId}/events/year/${year}/months/${month}`);
  }

  getEventsByOrganization(orgId: string, year: string, month: string) {
    return this.apiService.getCall('calendarEventsLink', `organizations/${orgId}/events/year/${year}/months/${month}`);
  }

  addAssociateUser(userId: string, user: any) {
    return this.apiService.putCall('calendarEventsLink', `users/${userId}/calendars/associates`, user);
  }

  getAssociatedUser(userId: string) {
    return this.apiService.getCall('calendarEventsLink', `users/${userId}/calendars/associates`);
  }

  removeAssociatedUser(userId: string, associateId: string) {
    return this.apiService.deleteCall('calendarEventsLink', `users/${userId}/calendars/associates/${associateId}`);
  }

  postEvent(calendarEvent: any, userId: string, orgId: string) {
    return this.apiService.postCall('calendarEventsLink', `organizations/${orgId}/events`, calendarEvent);
  }

  postUserEvent(calendarEvent: any, userId: string) {
    return this.apiService.postCall('calendarEventsLink', `users/${userId}/events`, calendarEvent);
  }

  putEvent(calendarEvent: any, eventId: string, orgId: string, userId: string) {
    return this.apiService.putCall('calendarEventsLink', `users/${userId}/events/${eventId}`, calendarEvent);
  }

  deleteEvent(orgId: string, id: string) {
    return this.apiService.deleteCall('calendarEventsLink', `organizations/${orgId}/events/` + id);
  }

  getCourtDates(year: string) {
    return this.apiService.getCall('calendarEventsLink', `year/${year}`);
  }

  getCourtDatesFirstTime() {
    return this.apiService.getCall('calendarEventsLink', `hearingdate`);
  }

  addCourtDate(year: any, data: any) {
    return this.apiService.putCall('calendarEventsLink', `year/${year}/add`, data);
  }

  removeCourtDate(year: any, data: any) {
    return this.apiService.putCall('calendarEventsLink', `year/${year}/remove`, data);
  }

  getDocketCases(orgId: any, year: any, month: any, date: any) {
    return this.apiService.getCall('calendarEventsLink', `organizations/${orgId}/docket/year/${year}/month/${month}/date/${date}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/calendarEvent.service.ts